import React, { Component } from "react";
import CheckedLogo from "swfrontend/assets/images/checked.svg";
import { Button } from "antd";
import "../../LandingPage.css"
import { successRegisteredText } from "../../constants";
import CRPFooter from "../../Components/CRPFooter/CRPFooter";

export default class SuccessRegister extends Component {
  onClick = (link) => {
    this.props.history.push(link);
  };

  render() {
    let state = this.props.history.location.state;

    return (
      <>
        <div className="success-padding">
          <center>
            <img className="checkedLogo" src={CheckedLogo} alt="" />
            <h4 className="successMessage">Registration Successful</h4>
          </center>
          <center>
            <h5 className="successMessage">{successRegisteredText}</h5>
          </center>

          {state !== undefined && (
            <center>
              <h6 className="successMessage">
                <br />
                {state.shipping_billing_msg}
              </h6>
              <br />
              <a href={state.shipping_billing_url} className="links">
                Click here to add shipping address
              </a>
            </center>
          )}

          <div className="success-buttons">
            <Button type="primary" onClick={() => this.onClick("Home")}>
              Home
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="primary" onClick={() => this.onClick("Login")}>
              Login
            </Button>
          </div>
        </div>
        <div className="footer-align">
          <CRPFooter />
        </div>
      </>
    );
  }
}
